<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <section class="content-header">
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'customers'}">
              Customers
            </router-link>
          </li>
          <li class="active">
            <a href="#">Add Customer</a>
          </li>
        </ol>
      </section>
      <!-- Main content -->
      <section class="content customers-content">
        <div class="box">
          <div class="box-body">
            <el-form
              :model="customer"
              :rules="rules"
              ref="customer"
              label-width="120px"
              label-position="top"
            >
              <el-form-item
                label="Name"
                prop="name"
              >
                <el-input v-model="customer.name"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('customer')"
                >Create</el-button>
                <el-button @click="resetForm('customer')">Reset</el-button>
              </el-form-item>
            </el-form>
            <hr>

          </div>
          <!-- /.box-body -->
        </div>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
import { mapActions } from 'vuex'
// import { required, minLength, between } from 'vuelidate/lib/validators'
export default {
  name: 'customer-add',
  data () {
    return {
      customer: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: 'Please input customer name', trigger: 'blur' },
          { min: 3, message: 'Length should be more then 3', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapActions('customers', ['addCustomer']),
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // debugger
          this.addCustomer(this.customer)
            .then(_ => this.$router.push({ name: 'customers' }))
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// Add.vue?91fb31f8